import React, { createContext, ReactNode, useContext, useState } from 'react';

export type ActiveType = {
  secondary: string;
  third: string;
};

type ContextType = {
  active: ActiveType;
  setActiveMenu: (type: ActiveType) => void;
};

type Prop = {
  children: ReactNode;
};

const Context = createContext({} as ContextType);

const AsideMenuListContext = ({ children }: Prop) => {
  const [active, setActive] = useState({} as ActiveType);

  const setActiveMenu = (object: ActiveType) => {
    setActive({ ...active, ...object });
  };

  return (
    <Context.Provider
      value={{
        active,
        setActiveMenu,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const useContextAsideMenuList = () => {
  return useContext(Context);
};

export default AsideMenuListContext;
